module.exports = __webpack_public_path__ + "img/austria-lung-cancer-female.da23ef97.png";